import { apiSlice } from "./apiSlice";
import { USER_FILE_URL } from "../../constants/urls";
import { resolveStoredFileId } from "../../utils/storedFile";

const toPrivateFileArgs = (arg) => {
  if (typeof arg === "string") {
    return { fileId: resolveStoredFileId(arg), variant: undefined };
  }
  return {
    fileId: resolveStoredFileId(arg?.fileId || arg),
    variant: arg?.variant,
  };
};

export const fileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPrivateFile: builder.query({
      async queryFn(arg, _api, _extraOptions, fetchWithBQ) {
        const { fileId, variant } = toPrivateFileArgs(arg);
        if (!fileId) {
          return { error: { status: 400, data: "invalid_file_id" } };
        }
        const q = variant ? `?variant=${variant}` : "";
        const result = await fetchWithBQ({
          url: `${USER_FILE_URL}/${fileId}/download${q}`,
          method: "GET",
          responseHandler: async (response) => response,
        });
        if (result.error) return { error: result.error };
        const response = result.data;
        if (!response?.ok || typeof response.blob !== "function") {
          return {
            error: {
              status: response?.status || 500,
              data: "file_fetch_error",
            },
          };
        }
        const blob = await response.blob();
        return { data: window.URL.createObjectURL(blob) };
      },
    }),
    uploadToHub: builder.mutation({
      query: (formData) => ({
        url: `${USER_FILE_URL}/upload`,
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const {
  useGetPrivateFileQuery,
  useLazyGetPrivateFileQuery,
  useUploadToHubMutation,
} = fileApiSlice;
